import { useQuery, QueryFunctionContext } from "@tanstack/react-query";
import { DashboardViewDTO } from "../types/dashboard";
import { HttpDashboard } from "../api/httpDashboard";
import {useEffect, useState} from "react";

interface DashboardParams {
  codPais: number;
  codMensajeTipo: number | null;
}

const fetchDashboard = async ({ queryKey }: QueryFunctionContext<[string, DashboardParams]>) => {
  const [, { codPais, codMensajeTipo }] = queryKey;

  return HttpDashboard.get(codPais, codMensajeTipo);
};

export const useDashboard = () => {
  const [queryKey, setQueryKey] = useState<[string, DashboardParams]>(['dashboard-por-sistema', { codPais: 1, codMensajeTipo: -1 }]);

  const { data: dashboardData, isLoading, refetch } = useQuery<DashboardViewDTO, Error, DashboardViewDTO, [string, DashboardParams]>({
    queryKey: queryKey,
    queryFn: fetchDashboard,
    enabled: false,
  });

  const refetchWithParams = (params: DashboardParams) => {
    setQueryKey(['dashboard-por-sistema', params]);
  };

  useEffect(() => {
    if (queryKey) {
      refetch();
    }
  }, [queryKey]);

  return { data: dashboardData, loading: isLoading, refetch: refetchWithParams };
};